import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { QuestionProps } from '@/app/models/question'
import Accordion from '../../../Layout/Accordion/Accordion'
import Question from '@/app/components/UI/Question/Question'
import { isMobileChecker } from '@/app/utils/commonFunctions'
import './Questions.scss'
import { setQuestionStatus } from '@/app/utils/newActivityQuestionsStatus'

const Questions = (props: {
    questions: QuestionProps[]
    setQuestions: (questions: QuestionProps[]) => void
    answerQuestion: (
        projectId: string,
        questionId: string,
        answer: any,
        jobId?: string,
        answerAttachments?: any[]
    ) => void
}) => {
    const { questions, setQuestions, answerQuestion } = props

    const intl = useIntl()

    const isMobile = isMobileChecker()

    const componentClass = 'smart-modals-news-execution-questions'

    const [activeIndex, setActiveIndex] = useState(1)
    const [disableAccordionFocus, setDisableAccordionFocus] = useState(false)

    const onUpdateAnswer = (a: any, q: QuestionProps) => {
        answerQuestion(q.projectId, q._id, a, null, q.answerAttachments)
        let tmpQuestions: QuestionProps[] = [...questions]
        let newQuestions: QuestionProps[] = []
        for (let i = 0; i < tmpQuestions.length; i++) {
            let tmpQuestion = tmpQuestions[i]
            if (tmpQuestion.id === q.id) {
                newQuestions.push({ ...tmpQuestion, answer: a })
            } else {
                newQuestions.push(tmpQuestion)
            }
        }
        // check to define status completed or not_completed
        newQuestions = newQuestions.map((q: QuestionProps) => setQuestionStatus(q))
        setQuestions(newQuestions)
    }

    const onUpload = (files, q: QuestionProps) => {
        let tmpQuestions: QuestionProps[] = [...questions]
        let newQuestions: QuestionProps[] = []
        let newQuestion: QuestionProps;
        for (let i = 0; i < tmpQuestions.length; i++) {
            let tmpQuestion = tmpQuestions[i]
            if (tmpQuestion.id === q.id) {
                newQuestion = {
                    ...tmpQuestion,
                    answerAttachments: [
                        ...q.answerAttachments,
                        ...files.map((file: any) => ({
                            file: file.file,
                            url: file.url,
                            id: file.id,
                            // hideEyeIcon: true
                        }))
                    ],
                }
                newQuestions.push(newQuestion)
            } else {
                newQuestions.push(tmpQuestion)
            }
        }
        // check to define status completed or not_completed
        newQuestions = newQuestions.map((q: QuestionProps) => setQuestionStatus(q))
        setQuestions(newQuestions)
        answerQuestion(q.projectId, q._id, q.answer, null, newQuestion.answerAttachments)
    }

    const setActiveIndexHandler = (i) => {
        if (typeof activeIndex !== null) setDisableAccordionFocus(false)
        setActiveIndex(i + 1)
    }
    const onCloseHandler = () => {
        setDisableAccordionFocus(true)
    }

    return (
        <div className={componentClass}>
            {isMobile && (
                <div className={`${componentClass}__info`}>
                    <div className={`${componentClass}__info__number_of`}>
                        <span>{`${intl.formatMessage({
                            id: 'modals.news_execution.project_specs.details.number_of',
                            defaultMessage: 'Number of',
                        })} ${intl.formatMessage({
                            id: 'modals.news_execution.action.action_card.title.questions',
                            defaultMessage: 'Questions',
                        })}`}</span>
                        <strong>{questions?.length}</strong>
                    </div>
                </div>
            )}
            {questions?.length > 0 ? (
                questions.map((q: QuestionProps, i: number) => {
                    return (
                        <Accordion
                            id={i}
                            key={i}
                            activeIndex={i}
                            title={q.question}
                            className={`${q.status} ${
                                !disableAccordionFocus && activeIndex === i + 1 ? 'has-focus' : ''
                            }`}
                            setActiveIndex={() => setActiveIndexHandler(i)}
                            onClose={onCloseHandler}>
                            <Question
                                question={q}
                                onUpload={onUpload}
                                onUpdateAnswer={onUpdateAnswer}
                                className={`${componentClass}__question`}
                            />
                        </Accordion>
                    )
                })
            ) : (
                <div>
                    {intl.formatMessage({
                        id: 'modals.news_execution.action.questions.no_questions',
                        defaultMessage: 'No questions.',
                    })}
                </div>
            )}
        </div>
    )
}

export default Questions
